export const initialCartState = {
  cart: [],
};
